import type { ZodType } from 'zod';

export const decode = <T>(parsedObject: unknown, schema: ZodType<T>): T => schema.parse(parsedObject);
